module.exports = __webpack_public_path__ + "static/media/bg-english-icon.ff520253.svg";